import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/apps/launchpad/components/pages/Main/Page.tsx");
